import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, ChevronDownIcon, PlusIcon, HistoryIcon, SaveIcon, CheckCircleIcon } from 'lucide-react';
import { Button } from '../components/common/Button';
import { Dropdown } from '../components/common/Dropdown';
import { mockData } from '../utils/mockData';
import { AffidavitModal } from '../components/AffidavitModal';
export const ReportEditor = () => {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  // Get report data or fallback to default
  const reportData = mockData.reports[id as keyof typeof mockData.reports] || mockData.reports.default;
  const [content, setContent] = useState(reportData.narrative);
  const [title, setTitle] = useState(reportData.incidentType || 'New Narrative Report');
  const [version, setVersion] = useState('v1.0');
  const [isAffidavitOpen, setIsAffidavitOpen] = useState(false);
  const versions = ['v1.0 (Current)', 'v0.9 (Draft)', 'v0.8 (Draft)'];
  return <div className="flex-grow flex flex-col h-screen bg-[#0a1120] text-[#e0e0e0] overflow-hidden" data-id="element-505">
      {/* Top Navigation Bar */}
      <header className="flex items-center justify-between px-6 py-3 border-b border-white/5 bg-[#0a1120]/50 backdrop-blur-md" data-id="element-506">
        <div className="flex items-center gap-4" data-id="element-507">
          <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-sm font-medium text-command-text-muted hover:text-white transition-colors group" data-id="element-508">
            <ArrowLeftIcon size={18} className="group-hover:-translate-x-0.5 transition-transform" data-id="element-509" />
            <span data-id="element-510">Back to Incident</span>
          </button>
        </div>

        <div className="flex items-center gap-4" data-id="element-511">
          <span className="text-xs text-command-text-muted" data-id="element-512">
            Updated{' '}
            <span className="text-white/60 font-medium" data-id="element-513">
              Apr 10, 2026, 10:22 AM
            </span>
          </span>
        </div>
      </header>

      {/* Editor Header Section */}
      <div className="max-w-[900px] mx-auto w-full px-8 pt-12 pb-6" data-id="element-514">
        <div className="mb-8" data-id="element-515">
          <input type="text" value={title} onChange={e => setTitle(e.target.value)} className="text-5xl font-bold bg-transparent border-none focus:outline-none focus:ring-0 w-full tracking-tight text-white placeholder:text-white/20" placeholder="Untitled Report" data-id="element-516" />
        </div>

        {/* Action Row */}
        <div className="flex items-center justify-between border-b border-white/5 pb-8" data-id="element-517">
          <div className="flex items-center gap-3" data-id="element-518">
            {/* Version Dropdown */}
            <Dropdown width="w-48" trigger={<button className="flex items-center gap-2 px-3 py-1.5 bg-white/5 border border-white/10 rounded-lg text-sm font-medium text-command-text-muted hover:text-white hover:bg-white/10 transition-all" data-id="element-520">
                  <HistoryIcon size={14} data-id="element-521" />
                  <span data-id="element-522">{version}</span>
                  <ChevronDownIcon size={12} data-id="element-523" />
                </button>} data-id="element-519">
              <div className="py-1" data-id="element-524">
                <div className="px-3 py-1.5 text-[10px] font-bold text-command-text-muted uppercase tracking-wider" data-id="element-525">
                  Version History
                </div>
                {versions.map(v => <button key={v} onClick={() => setVersion(v.split(' ')[0])} className="w-full text-left px-3 py-2 text-xs text-[#e0e0e0] hover:bg-white/5 transition-colors" data-id="element-526">
                    {v}
                  </button>)}
              </div>
            </Dropdown>
          </div>

          <div className="flex items-center gap-3" data-id="element-527">
            <Button variant="secondary" size="sm" icon={CheckCircleIcon} className="bg-white/5 border-white/10 hover:bg-white/10" onClick={() => setIsAffidavitOpen(true)} data-id="element-528">
              Finalize
            </Button>
            <Button variant="primary" size="sm" icon={SaveIcon} className="shadow-lg shadow-primary/20" data-id="element-529">
              Save
            </Button>
          </div>
        </div>
      </div>

      {/* Editor Body */}
      <div className="flex-grow overflow-y-auto custom-scrollbar pb-32" data-id="element-530">
        <div className="max-w-[900px] mx-auto px-8" data-id="element-531">
          <textarea value={content} onChange={e => setContent(e.target.value)} className="w-full h-full bg-transparent border-none focus:outline-none focus:ring-0 text-xl leading-relaxed text-white/90 resize-none min-h-[600px] font-medium" placeholder="Start writing your narrative report..." data-id="element-532" />
        </div>
      </div>

      <AffidavitModal isOpen={isAffidavitOpen} onClose={() => setIsAffidavitOpen(false)} onConfirm={() => {
      setIsAffidavitOpen(false);
      alert('Report finalized and affidavit signed.');
    }} data-id="element-533" />
    </div>;
};